<template>
  <div class="board-detail">
    <div v-if="articleInfo.cardNo" :class="navKey">
      <div :class="`${navKey}-info`">
        <div :class="`${navKey}-info-container`">
          <inner-header img-url="/assets/images/header-inner-bar.png" />
          <div class="article-info">
            <div class="article-info-content">
              <div class="article-info-left">
                <div class="article-title">{{ articleInfo.title }}</div>
                <div class="article-tag" v-if="isZiYuan">
                  <template v-if="isDesign">
                    <template v-if="useMobileUI">
                      <span>{{ modeTag }}</span>
                      <span>{{ formatDateTime(articleInfo.regDt) }}</span>
                    </template>
                    <template v-else>
                      <span>风格：{{ modeTag }}</span>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="useMobileUI">
                      <span>{{ modeClassify }}</span>
                      <span>{{ modePlayer }}</span>
                      <span>v{{ articleInfo.ugcMeta.version }}</span>
                      <span>{{ formatDateTime(articleInfo.regDt) }}</span>
                    </template>
                    <template v-else>
                      <span>游戏类型：{{ modeClassify }}</span>
                      <span>模式：{{ modePattern }}</span>
                      <span>支持人数：{{ modePlayer }}</span>
                      <span>标签：{{ modeTag }}</span>
                    </template>
                  </template>
                </div>
                <div class="article-icon">
                  <div class="article-icon-author" v-if="useMobileUI">
                    <div class="author-left">
                      <image-thumb
                        :src="authorInfo.avatar"
                        :size="isZiYuan ? 'mini' : 'middle'"
                      />
                    </div>
                    <div class="author-right">
                      <div class="author-name">{{ authorInfo.nickname }}</div>
                      <p>{{ formatDateTime(articleInfo.regDt) }}</p>
                    </div>
                  </div>
                  <div class="article-icon-left">
                    <heat-degree :value="articleInfo.readCnt" inline />
                    <span class="article-icon-version" v-show="articleInfo.ugcMeta.version">
                      <i></i>
                      {{ articleInfo.ugcMeta.version }}
                    </span>
                    <span class="article-icon-date">
                      <i></i>
                      {{ formatDateTime(articleInfo.regDt) }}
                    </span>
                  </div>
                  <div class="article-icon-right">
                    分享到：
                    <i class="article-icon-weixin"></i>
                    <i
                      v-stlog="{ shareToSina: null }"
                      class="article-icon-weibo"
                      @click="shareTo('sina')"
                    ></i>
                    <i
                      v-stlog="{ shareToQQ: null }"
                      class="article-icon-qq"
                      @click="shareTo('qq')"
                    ></i>
                    <i
                      v-stlog="{ shareToQzone: null }"
                      class="article-icon-qq-zone"
                      @click="shareTo('qzone')"
                    ></i>
                    <div class="weixin-code">
                      <img :src="weixinCode" alt="">
                    </div>
                  </div>
                </div>
                <template v-if="isZiYuan">
                  <div class="article-score">
                    <score-star :score="scoreValue" />
                  </div>
                  <div class="article-banner">
                    <Banner :list="mediaList" />
                  </div>
                  <p class="article-subTitle">{{ isDesign ? '作品说明' : '模式说明' }}</p>
                </template>
                <div
                  v-if="isVideo && useMobileUI"
                  class="article-video"
                  id="video"
                ></div>
                <div
                  v-html="articleContent"
                  class="article-content"
                  ref="content"
                  v-else
                ></div>
              </div>
              <div class="article-info-right">
                <div class="article-author" v-if="!useMobileUI">
                  <div class="article-author-image">
                    <image-thumb :src="authorInfo.avatar" size="large" />
                  </div>
                  <div class="article-author-name ellipsis">{{ authorInfo.nickname }}</div>
                </div>
                <div class="article-recommend" v-if="recommendList.length">
                  <div class="article-recommend-header">
                    <span class="article-recommend-title">相关推荐</span>
                    <span
                      class="article-recommend-button"
                      v-if="boardFeedList.length > 5"
                      @click="getRecommendList"
                    >
                      <i></i>
                      换一批
                    </span>
                  </div>
                  <recommend-list :list="recommendList" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="useMobileUI" class="card-list-tips">加载中~</div>
  </div>
</template>

<script>
import FeedDetail from '@/components/base/Detail/FeedDetail';

import Banner from '@/components/Banner/Banner';
import ScoreStar from '@/components/Score/ScoreStar';
import ImageThumb from '@/components/common/ImageThumb';
import HeatDegree from '@/components/common/HeatDegree';
import InnerHeader from '@/components/common/InnerHeader';
import RecommendList from '@/components/List/RecommendList';

export default {
  name: 'BoardDetail',

  mixins: [FeedDetail],

  components: {
    Banner,
    ScoreStar,
    ImageThumb,
    HeatDegree,
    InnerHeader,
    RecommendList
  },

  computed: {
    navKey() {
      return this.$route.params.navKey;
    }
  }
};
</script>
